import { createTestIds } from '../../utils';

export const getFieldValueListTestIds = createTestIds('field-value-list', [] as const);

export const getFieldValueItemTestIds = createTestIds('field-value-item', [
  'name',
  'value'
] as const);
